import { Switch } from "antd";
import React, { useEffect, useState } from "react";
import { enableBusinessMessages, getBusiness } from "../../../../api/business";

const Messaging = () => {
    const [business, setBusiness] = useState();

    const getCurrentBusiness = async () => {
        const res = await getBusiness();
        if (res) {
            setBusiness(res);
        }
    }

    useEffect(() => {
        getCurrentBusiness();
    }, [])

    const handleMessagingToggle = async (id, checked) => {
        const payload = {
            isMessagesEnabled: checked
        }
        const res = await enableBusinessMessages(id, payload)
        if (res) {
            setBusiness(res);
        }
    };

    return (
        <div className="px-3">
            <p className="text-lg font-medium  tracking-wider">
                Enable/Disable Messaging
            </p>
            <Switch
                checked={business?.isMessagesEnabled ?? true}
                onChange={(checked) => handleMessagingToggle(business?._id, checked)}
                className={`${(business?.isMessagesEnabled ?? true) ? '!bg-primaryPurple' : '!bg-gray-400'}`}
                style={{
                    backgroundColor: (business?.isMessagesEnabled ?? true) ? '#6B4EFF' : '#9CA3AF',
                }}
            />
        </div>
    );
};

export default Messaging;